import React, { useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectCurrentUser } from 'ducks/currentUser'
import Announcement, {
  animations,
} from '@groovehq/internal-design-system/lib/components/Announcement/Announcement'
import Button from '@groovehq/internal-design-system/lib/components/Button/Button'
import { styles } from '@groovehq/internal-design-system/lib/components/Announcement/Announcement.styles'
import eric from 'assets/eric-big.png'
import useCalendlyWidget from 'util/hooks/useCalendlyWidget'
import { strftime } from 'util/date'
import { HIDE_WEBINAR_ANNOUNCEMENT } from 'ducks/flags/flagNames'
import { doSetFlag } from 'ducks/flags'
import { styles as layoutStyles } from './styles'

const CALENDLY_URL = 'https://calendly.com/eric-groovehq/newfeatures'

const WebinarAnnouncement = () => {
  const dispatch = useDispatch()
  const currentUser = useSelector(selectCurrentUser)
  const [show, setShow] = useState(true)

  const handleCloseCard = useCallback(
    () => {
      setShow(false)
      dispatch(doSetFlag(HIDE_WEBINAR_ANNOUNCEMENT))
    },
    [dispatch]
  )

  const handleScheduleClick = useCallback(
    () => {
      const defaultYearMonth = `month=${strftime('%Y-%m', new Date())}`
      const url = `${CALENDLY_URL}?${defaultYearMonth}`
      if (!window.Calendly) {
        window.open(URL, url)
        return
      }
      window.Calendly.initPopupWidget({
        url,
        hide_gdpr_banner: true,
        prefill: {
          email: currentUser.email,
          name: `${currentUser.first_name} ${currentUser.last_name}`,
        },
      })
    },
    [currentUser]
  )

  useCalendlyWidget({
    onScheduleSuccess: handleCloseCard,
  })

  const footer = useMemo(
    () => (
      <div className="grui pl-11 pb-12">
        <Button
          type="primary"
          size="xBig"
          css={[styles.btn, layoutStyles.webinarAnnouncementBtn]}
          className="grui mr-7"
          onClick={handleScheduleClick}
        >
          Join the webinar
        </Button>
      </div>
    ),
    [handleScheduleClick]
  )

  return (
    <Announcement.AnimatePresenceMotion
      open={show}
      initialAnimation={animations.initial}
      endAnimation={animations.end}
    >
      <Announcement
        onClose={handleCloseCard}
        tag="Webinar"
        title="Want to learn how to use the exciting new features available on your account?"
        css={layoutStyles.announcementContainer}
        copy={
          <>
            Join Eric this{` `}
            <strong>Thursday 10AM PST</strong>
            {` `}for a live webinar where he&apos;ll share all the new
            improvements, our plans for Q2, and answer customer questions!
          </>
        }
        footer={footer}
      >
        <div
          css={[styles.imgWrapper, layoutStyles.webinarAccouncementImgWrapper]}
        >
          <img width="312" height="239" src={eric} alt="Eric Stein" />
        </div>
      </Announcement>
    </Announcement.AnimatePresenceMotion>
  )
}

export default WebinarAnnouncement
